export const currencies = [
    { 'value': 'USD', 'name': 'USD - US Dollar' },
    { 'value': 'EUR', 'name': 'EUR - Euro' },
    { 'value': 'AUD', 'name': 'AUD - Australian Dollar' },
    { 'value': 'GBP', 'name': 'GBP - British Pound' },
    { 'value': 'JPY', 'name': 'JPY - Japanese Yen' },
];
